var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 826.75,
    height: 30,
    viewBox: "0 0 826.75 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(-289 -106)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_51",
    "data-name": "Line 51",
    x2: 132,
    transform: "translate(317.5 121.5)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_52",
    "data-name": "Line 52",
    x2: 132,
    transform: "translate(476.25 121.5)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_53",
    "data-name": "Line 53",
    x2: 132,
    transform: "translate(635.25 121.5)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_54",
    "data-name": "Line 54",
    x2: 132,
    transform: "translate(794.25 121.5)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_59",
    "data-name": "Line 59",
    x2: 132,
    transform: "translate(955 121.5)",
    fill: "none",
    stroke: "#ebeaed",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#dc2342",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#dc2342"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(159.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-2",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-2",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-3",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-3",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-4",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-4",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-5",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-5",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(796.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9-6",
    "data-name": "Ellipse 9",
    transform: "translate(289 106)",
    fill: "#fff",
    stroke: "#ebeaed",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10-6",
    "data-name": "Ellipse 10",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(295 112)",
    fill: "#ebeaed"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg0);
export default __webpack_public_path__ + "static/media/0.4bb26d9803189ccaa80e387a064db460.svg";
export { ForwardRef as ReactComponent };